import { useUser } from "@/modules/users/hooks/useUser"
import { useProgramBundle } from "@modules/programBundle/hooks/useProgramBundle"
import { useEffect, useState } from "react"

export const useProgramBundleRights = (programBundleId: string) => {
  const { data: programBundle } = useProgramBundle(programBundleId)
  const user = useUser()
  const [isAuthor, setIsAuthor] = useState(false)

  useEffect(() => {
    if (user && programBundle && user.id === programBundle.owner.id) {
      setIsAuthor(true)
    } else {
      setIsAuthor(false)
    }
  }, [JSON.stringify(programBundle), JSON.stringify(user)])

  return { isAuthor }
}
